import { store } from '../store/store';

export default {

  show() {
    store.commit('showLoader');
  },

  hide() {
    store.commit('hideLoader');
  },

  install(Vue, options) {
    Vue.prototype.loader = this;
  }

}



// WEBPACK FOOTER //
// ./src/helpers/loaderModule.js